import { products } from "../../../data/products";
import Container from "../../layout/Container";
import Paginate from "../../layout/Paginate";
import ProductCard from "../../Shared/Product/ProductCard";

const FeaturedList = () => {
  return (
    <Container>
      <h3 className="mt-9 mb-8 font-pop text-[28px] font-medium">
        Featured List
      </h3>
      <div className="my-8 gap-4">
        <Paginate
          element={(item) => <ProductCard product={item} />}
          data={products}
          itemsPerPage={10}
        />
      </div>
    </Container>
  );
};

export default FeaturedList;
